import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { URL_GLOBAL } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NotificacaoServices {

    UrlApiNotificacao = 'https://onesignal.com/api/v1/notifications';

    constructor(private http: HttpClient, private authService: AuthService) { }
    //###############   notificacao   ###############
    EnviaNotificacao(data: any) {

        var config = {
            headers: {
                'Authorization': 'Basic Yjk2NjA1ODEtODJjNC00Njk0LTkzY2UtZDIzMGI3ODEyYzZi',
                'Content-Type': 'application/json; charset=utf-8'

            }
        }
        return this.http.post(this.UrlApiNotificacao, data, config);

    }
    pegarNotificacoes(): Observable<any[]> {
        return this.http.get<any[]>(`${URL_GLOBAL}/web/notificacoes`, { headers: this.authService.userToken() });
    }
    find(id: any): Observable<any> {
        return this.http.get(`${URL_GLOBAL}/web/notificacoes/${id}`, { headers: this.authService.userToken() });
    }
    salvarNovoServico(notificacao,): Observable<any> {
        return this.http.post<any>(`${URL_GLOBAL}/web/notificacoes`, notificacao, { headers: this.authService.userToken() });
    }
    atualizarServico(id, notificacao,): Observable<any> {
        return this.http.put<any>(`${URL_GLOBAL}/web/notificacoes/${id}`, notificacao, { headers: this.authService.userToken() });
    }
    excluirNotificacao(id): Observable<any> {
        return this.http.delete(`${URL_GLOBAL}/web/notificacoes/${id}`, { headers: this.authService.userToken() })
    }
    notificacoesporprofissional(id): Observable<any[]> {
        return this.http.get<any[]>(`${URL_GLOBAL}/web/notificacoes/profissional/${id}`, { headers: this.authService.userToken() })
    }
}